"use strict";
import { jsx } from "react/jsx-runtime";
import { ActionBars as ActionBarsPrimitive } from "capitalrx-components-2.0/lib/shell";
import { useContentChannel } from "./ContentChannel";
import { BreadcrumbItems } from "./Breadcrumb";
import { useLayout } from "../ContentLayout";
export const ActionBars = () => {
  const actionBarSubscriptions = useContentChannel(null, "app-action-bars");
  const layoutType = useLayout();
  const actions = actionBarSubscriptions.map((subscription, index) => ({
    id: `${subscription.module.id}-${index}`,
    content: /* @__PURE__ */ jsx(subscription.component, {})
  }));
  return /* @__PURE__ */ jsx(
    ActionBarsPrimitive,
    {
      actions,
      layoutType,
      breadcrumbs: /* @__PURE__ */ jsx(BreadcrumbItems, {})
    }
  );
};
